import React from 'react'
import { Views } from '../../views'

const Package = () => {
    const { Package } = Views
    return (
        <div>
            <Package />
        </div>
    )
}

export default Package
